module.exports = __webpack_public_path__ + "static/media/pic-apartment.49ef9976.webp";